module.exports = __webpack_public_path__ + "img/Logo_Governança_Empreendedora-azul.7eea3596.png";